import { Grid, IconButton, Tooltip, useEventCallback } from '@mui/material';
import { memo, useEffect, useState } from 'react';
import { AccordionAttachmentsVM } from 'practice/view-models/practice-detail';
import { PmiInputFile } from 'shell/components/shared/file-input';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteDialog from 'shell/components/shared/delete-dialog';

interface FormProps {
  disabled?: boolean;
  onChange: (
    key: keyof AccordionAttachmentsVM,
    value: AccordionAttachmentsVM[keyof AccordionAttachmentsVM]
  ) => void;
  values?: AccordionAttachmentsVM;
  onSave: (value: File) => void;
  onTrash: (value: File | undefined, index: number | undefined) => void;
}

export interface TypeFile extends File {
  idAllegato?: number;
  idAnscAllegato?: number;
  raw?: string;
  tipoAllegato?: string;
  codStato?: string;
  description?: string;
  idTipoAllegato?: string;
}

const FormComponent = ({
  disabled,
  onChange,
  values,
  onSave,
  onTrash,
}: FormProps): React.ReactElement => {
  const [modal, setModal] = useState<Record<string, boolean | number | undefined>>({
    open: false,
    indexCurr: undefined,
  });

  useEffect(() => {
    if (values?.isNotDocument) {
      // reset files
      onChange('files', undefined);
    }
  }, [values?.isNotDocument]);

  const handleAddFile = useEventCallback((files: Array<File>) => {
    onSave(files[0]);
  });

  const onTrashPress = useEventCallback(() => {
    const indexCurr: number | undefined = Number.parseInt(
      (typeof modal.indexCurr === 'number' ? modal.indexCurr : '').toString()
    );

    const newFiles: Array<TypeFile> = values?.files?.slice() || [];

    onTrash(
      newFiles.find((_, index) => index === indexCurr),
      indexCurr
    );

    setModal({ open: false, indexCurr: undefined });
  });

  return (
    <Grid container spacing={2}>
      {/* <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              id="isNotDocument"
              checked={values?.isNotDocument || false}
              onChange={() => onChange('isNotDocument', !values?.isNotDocument)}
              inputProps={{ 'aria-label': 'Non sono presenti documenti da allegare alla pratica' }}
              disabled={disabled}
            />
          }
          label="Non sono presenti documenti da allegare alla pratica"
        />
      </Grid> */}
      <Grid item xs={12}>
        Carica documento&nbsp;
        <PmiInputFile
          files={values?.files}
          onChange={handleAddFile}
          color="cdmBrandThird"
          multiple
          hideList
          disabled={disabled || values?.isNotDocument}
          accept="application/pdf"
        />
      </Grid>
      <Grid item xs={12}>
        {values?.files?.map((file, index) => (
          <Grid container spacing={2} item xs={12} key={`file-${file.name}-${index}`}>
            <Grid item xs={12} md={4}>
              <Tooltip
                arrow
                title={
                  values.descriptions && values.descriptions[index]
                    ? values.descriptions[index]
                    : ''
                }
              >
                <a download={file.name} href={file.raw}>
                  {file.name}
                </a>
              </Tooltip>
            </Grid>
            <Grid item xs={12} md={5}>
              <IconButton
                color="error"
                disabled={disabled}
                aria-label="eliminare documento allegato"
                component="span"
                onClick={() => setModal({ open: true, indexCurr: index })}
              >
                <DeleteIcon />
              </IconButton>
            </Grid>
          </Grid>
        ))}
      </Grid>
      <DeleteDialog
        isOpen={Boolean(modal.open)}
        onAbort={() => setModal({ open: false, indexCurr: undefined })}
        onClose={() => setModal({ open: false, indexCurr: undefined })}
        onConfirm={() => onTrashPress()}
      />
    </Grid>
  );
};

FormComponent.displayName = 'Practice Detail - Form - accordion contacts - form';

const Form = memo(FormComponent);

export default Form;
